export class Load extends Phaser.Scene {
  init(config = {}) {}

  create() {
    this.load.on('start', this._renderLoader, this);
    this.load.on('complete', this._clearLoader, this);
  }

  _renderLoader() {
    if (!this.textures.exists('background_generic')) return;
    this._clearLoader();
    switch (this.game.loaderType) {
      case 'energy':
      case 'fauna':
      case 'flora':
      case 'food':
      case 'recycling':
      case 'travel':
      case 'water':
        this.assets = [
          this.add.image(840, 360, 'background_level'),
          this.add.image(840, 250, 'loader', 'loader_bg'),
          this.add.image(840, 350, 'loader', 'loader_' + this.game.loaderType + '_01'),
        ];
        this.fg = this.add.image(840, 350, 'loader', 'loader_' + this.game.loaderType + '_02');
        this.bar = this.make.graphics();
        this.bar.x = this.fg.x - this.fg.displayWidth * 0.5;
        this.bar.y = this.fg.y - this.fg.displayHeight * 0.5;
        this.bar.setData('move', {
          y: this.bar.y + this.fg.displayHeight,
          dist: -this.fg.displayHeight,
        });
        this.bar.fillStyle(0xff0000);
        this.bar.fillRect(0, 0, this.fg.displayWidth, this.fg.displayHeight);
        this.fg.mask = this.bar.createGeometryMask();

        this.assets.push(this.fg, this.bar);
        break;
      default:
        this.assets = [
          this.add.image(840, 360, 'background_generic'),
          this.add.image(840, 360, 'loader', 'loading'),
        ];
        this.bar = this.add.graphics();
        this.assets.push(this.bar);
        break;
    }
  }

  _clearLoader() {
    if (this.assets) {
      this.assets.forEach((asset) => {
        asset.destroy();
      });
      this.assets = null;
    }
  }

  setProgress(value) {
    switch (this.game.loaderType) {
      case 'energy':
      case 'fauna':
      case 'flora':
      case 'food':
      case 'recycling':
      case 'travel':
      case 'water':
        if (this.bar) {
          const { y, dist } = this.bar.getData('move');
          this.bar.y = y + dist * value;
        }
        break;
      default:
        if (this.bar) {
          this.bar.clear();
          this.bar.lineStyle(30, 0xefe14f, 1);
          this.bar.beginPath();
          this.bar.arc(
            840,
            360,
            130,
            Phaser.Math.DegToRad(-90),
            Phaser.Math.DegToRad(360 * value - 90)
          );
          this.bar.strokePath();
          this.bar.fillStyle(0xefe14f, 1);
          this.bar.fillCircle(840, 360 - 130, 15);
          this.bar.fillCircle(
            840 - Math.sin(Phaser.Math.DegToRad(360 * value + 180)) * 130,
            360 + Math.cos(Phaser.Math.DegToRad(360 * value + 180)) * 130,
            15
          );
        }
        break;
    }
  }
}
